import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

import { SelectOption } from 'ish-core/models/select-option/select-option.model';

/**
 * Type for a basic select field
 *
 * @props **options**  defines options to be shown as key value pairs. Accepts two types:
 * * `` { value: any; label: string}[]``
 * * `` Observable<{ value: any; label: string}[]>``
 * @props **placeholder** defines the placeholder string that will be used as the first / default option
 *
 * @defaultWrappers form-field-horizontal & validation
 *
 * @usageNotes
 * The select field functionality is coupled with the translate-select-options extension. It reads the ``options`` and ``placeholder``
 * from the configuration and writes them to ``props.processedOptions``.
 * Please don't use ``props.processedOptions`` manually.
 *
 */

@Component({
  selector: 'custom-select-field',
  templateUrl: './custom-select-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgSelectComponent,
    ReactiveFormsModule,
    FormlyModule,
    NgClass,
    NgOptionComponent,
    AsyncPipe,
    FormlySelectModule,
  ],
})
export class CustomSelectFieldComponent extends FieldType<FieldTypeConfig> {
  defaultOptions = {
    props: {
      options: [] as SelectOption[],
      compareWith(o1: unknown, o2: unknown) {
        return o1 === o2;
      },
    },
  };
  get selectOptions() {
    return this.props.processedOptions ?? this.props.options;
  }
  makeBlur(component: NgSelectComponent) {
    component.blur();
  }
}
